const AddressUtil = {

  formatAddress: function (address) {
    if (address) {
      return address.substring(0, 5) + "..." + address.slice(-3);
    }
    return address;
  },
};

export default AddressUtil;